import { PaymentMethodEnum } from 'src/features/companies/companies.types';

export interface HeadsetStatus {
  apMacAddress: string;
  battery: number;
  cardState: string;
  firmware: string;
  lastActivity: string;
  alive: boolean;
  charging: boolean;
}

export interface ActiveHeadsetSubscription {
  id: string;
  expireAt: string;
  createdAt: string;
  packageId: string;
  duration: number;
}

export enum WorkingModeEnum {
  reception = 'reception',
  inRoom = 'in_room',
  vipAccess = 'vip_access',
}

export interface Room {
  id: string;
  name: string;
  archived: string;
  disabled: string;
  is_test: string;
}

export enum PaymentStatusEnum {
  pending = 'pending',
  succeeded = 'succeeded',
  canceled = 'canceled',
}

export enum PaymentInitiatorEnum {
  headset = 'headset',
  qr_code = 'qr_code',
  desk = 'desk',
}

export interface HeadsetInvoice {
  id: string;
  paymentMethod: PaymentMethodEnum;
  paymentStatus: PaymentStatusEnum;
  paymentInitiator: PaymentInitiatorEnum;
  currency: string;
  packageId: string;
  price: number;
  createAt: string;
  updatedAt: string;
  isTest: boolean;
}

export interface HeadsetSubscription {
  id: string;
  price: number;
  duration: number;
  createAt: string;
  canceledAt: string;
  expiredAt: string;

  paymentMethod: PaymentMethodEnum;
  paymentInitiator: PaymentInitiatorEnum;
}

export interface Device {
  id: string;
  type: string;
  active: boolean;
  disabled: boolean;
  vipAccess: boolean;
  isTest: boolean;
  hasActiveSession: boolean;
  phyDeviceId: string;
  label: string;
  roomLabel?: string;
  lastPayment: string;
  room?: Room;
  workingMode: WorkingModeEnum;
  status: HeadsetStatus;
  activeSubscriptions: ActiveHeadsetSubscription[];
  paymentMethods: string[];

  invoices: HeadsetInvoice[];
  subscriptions: HeadsetSubscription[];
  humanId: bigint;
}
